import * as React from 'react';

const EyeSlashOutlineIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 3.75L19.5 20.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5223 14.7747C13.7864 15.4436 12.8149 15.7928 11.8215 15.7454C10.8281 15.6981 9.89422 15.2581 9.22524 14.5222C8.55626 13.7863 8.20698 12.8149 8.25424 11.8215C8.3015 10.8281 8.74142 9.89414 9.47724 9.2251"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.93698 6.43066C3.11486 8.36618 1.5 12 1.5 12C1.5 12 4.5 18.7493 12 18.7493C13.7572 18.7633 15.4926 18.3585 17.0623 17.5685"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5566 15.8528C21.6006 14.0222 22.4995 11.9998 22.4995 11.9998C22.4995 11.9998 19.4995 5.24904 11.9995 5.24904C11.3499 5.24798 10.7014 5.30079 10.0605 5.40693"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7061 8.31641C13.5031 8.46945 14.229 8.8768 14.775 9.47734C15.3209 10.0779 15.6574 10.8392 15.734 11.6472"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeSlashOutlineIcon;
